let personReplacements = {
    'AGE': (person, variableModifier) => {
        return person.age + (variableModifier ? parseInt(variableModifier, 10) : 0);
    },
    'HE/SHE': ['he', 'she'],
    'HIM/HER': ['him', 'her'],
    'HIS/HER': ['his', 'her'],
    'HIS/HERS': ['his', 'hers'],
    'BOY/GIRLFRIEND': ['boyfriend', 'girlfriend'],
    'HUSBAND/WIFE': ['husband', 'wife'],
};

let oneManyReplacements = {
    'I/WE': ['i', 'we'],
    'ME/US': ['me', 'us'],
    'MY/OUR': ['my', 'our'],
    'MINE/OURS': ['mine', 'ours'],
    'I\'M/WE\'RE': ['i\'m', 'we\'re'],
};

let childReplacements = {
    // Child-specific codes
    'BOY/GIRL': ['boy', 'girl'],
    'SON/DAUGHTER': ['son', 'daughter'],
    'GRANDSON/DAUGHTER': ['grandson', 'granddaughter'],
    'NEPHEW/NIECE': ['nephew', 'niece'],
};

let adultReplacements = {
    // Adult-specific codes
    'MAN/WOMAN': ['man', 'woman'],
    'FATHER/MOTHER': ['father', 'mother'],
    'GRANDFATHER/MOTHER': ['grandfather', 'grandmother'],
    'UNCLE/AUNT': ['uncle', 'aunt'],
};

let _replacements = {};

for (let replacement in personReplacements) {
    let replaceWith = personReplacements[replacement];

    let childReplacement;
    let adultReplacement;

    if (replaceWith instanceof Array) {
        // It's a gender replacement
        childReplacement = function(child, adult) {
            if (!child) {
                return replacement;
            }

            return child.gender === 'male' ? replaceWith[0] : replaceWith[1];
        };

        adultReplacement = function(child, adult) {
            if (!adult) {
                return replacement;
            }

            return adult.gender === 'male' ? replaceWith[0] : replaceWith[1];
        };
    } else if (typeof(replaceWith) === 'function') {
        childReplacement = function(child, adult, variableModifier) {
            if (!child) {
                return null;
            }

            return replaceWith(child, variableModifier);
        };

        adultReplacement = function(child, adult, variableModifier) {
            if (!adult) {
                return null;
            }

            return replaceWith(adult, variableModifier);
        };
    }

    _replacements[`CHILD_${replacement}`] = childReplacement;
    _replacements[`ADULT_${replacement}`] = adultReplacement;
}

for (let replacement in childReplacements) {
    let replaceWith = childReplacements[replacement];
    let childReplacement;

    if (replaceWith instanceof Array) {
        // It's a gender replacement
        childReplacement = function(child, adult) {
            if (!child) {
                return null;
            }

            return child.gender === 'male' ? replaceWith[0] : replaceWith[1];
        };
    } else if (typeof(replaceWith) === 'function') {
        childReplacement = function(child, adult, variableModifier) {
            if (!child) {
                return null;
            }

            return replaceWith(child, variableModifier);
        };
    }

    _replacements[`${replacement}`] = childReplacement;
}

for (let replacement in adultReplacements) {
    let replaceWith = adultReplacements[replacement];
    let adultReplacement;

    if (replaceWith instanceof Array) {
        // It's a gender replacement
        adultReplacement = function(child, adult) {
            if (!adult) {
                return null;
            }

            return adult.gender === 'male' ? replaceWith[0] : replaceWith[1];
        };
    } else if (typeof(replaceWith) === 'function') {
        adultReplacement = function(child, adult, variableModifier) {
            if (!adult) {
                return null;
            }

            return replaceWith(adult, variableModifier);
        };
    }

    _replacements[`${replacement}`] = adultReplacement;
}

for (let replacement in oneManyReplacements) {
    let replaceWith = oneManyReplacements[replacement];
    let oneManyReplacement;

    if (replaceWith instanceof Array) {
        // It's a one/many replacement
        oneManyReplacement = function(child, adult) {
            let isMultiples = !!child && !!adult;
            let isSingle = !isMultiples;

            return isSingle ? replaceWith[0] : replaceWith[1];
        };
    } else if (typeof(replaceWith) === 'function') {
        oneManyReplacement = function(child, adult) {
            let isMultiples = !!child && !!adult;
            let isSingle = !isMultiples;

            return replaceWith(isSingle);
        };
    }

    _replacements[`${replacement}`] = oneManyReplacement;
}

console.log('_replacements', _replacements);

export const replacements = _replacements;
